export const AuthObservabilityEvents = {
  LOGIN_SUCCEEDED: 'login_succeeded',
  LOGIN_FAILED: 'login_failed',
  LOGOUT: 'logout',
  ACCESS_DENIED: 'access_denied',
} as const;

export interface AuthLoginFailedPayload {
  readonly errorCode: string;
}
